import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#0A2540] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Top Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12 border-b border-white/10">
          {/* Brand */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/a869bec1-8529-4662-b736-d7a3982f1bf1.png"
              alt="BOBROWSKA Logo"
              className="h-10 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-white/60 text-sm leading-relaxed">
              Conseil en gestion et développement d&apos;entreprise.<br />
              Ewa Bobrowska — Entrepreneur individuel
            </p>
            <p className="text-white/40 text-xs mt-3">SIRET : 100 085 687 00018</p>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-xs uppercase tracking-widest text-white/40 mb-5">Navigation</p>
            <ul className="flex flex-col gap-3">
              {[
                { label: "Accueil", path: "/" },
                { label: "À propos", path: "/a-propos" },
                { label: "Contact", path: "/contact" },
                { label: "Conditions générales", path: "/conditions-generales" },
                { label: "Politique de confidentialité", path: "/politique-de-confidentialite" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/70 hover:text-white text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-xs uppercase tracking-widest text-white/40 mb-5">Contact</p>
            <ul className="flex flex-col gap-3 text-sm text-white/70">
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-white/40"></i>
                </span>
                <span>49 Rue<br />67130 Wisches, France</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-white/40"></i>
                </span>
                <a href="tel:+33605613058" className="hover:text-white transition-colors">
                  +33 6 05 61 30 58
                </a>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-white/40"></i>
                </span>
                <a href="mailto:ewabobroowska@outlook.com" className="hover:text-white transition-colors break-all">
                  ewabobroowska@outlook.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/40">
          <p>© {new Date().getFullYear()} BOBROWSKA — Ewa Bobrowska. Tous droits réservés.</p>
          <div className="flex items-center gap-4">
            <Link to="/conditions-generales" className="hover:text-white/70 transition-colors whitespace-nowrap">
              Conditions générales
            </Link>
            <span>|</span>
            <Link to="/politique-de-confidentialite" className="hover:text-white/70 transition-colors whitespace-nowrap">
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
